import { Button, Flex, Title, Text } from '@mantine/core';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { storePaymentIntent } from '../../../utils';

export const PaymentValidation = () => {
  const parameters = new URLSearchParams(window.location.search);
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const paymentIntent = parameters.get('payment_intent');
  const clientSecret = parameters.get('payment_intent_client_secret');

  if (paymentIntent && clientSecret) {
    storePaymentIntent(paymentIntent, clientSecret);
  }

  useEffect(() => {
    void navigate('/measurement/order');
  });

  return (
    <Flex
      gap={'var(--mantine-spacing-lg)'}
      direction={'column'}
      justify={'center'}
      style={{ height: '100%' }}
    >
      <Title ta={'center'}>{t('redirecting_title')}</Title>
      <Text ta={'center'}>{t('redirecting_message')}</Text>
      <Button onClick={() => void navigate('/measurement/order')}>
        {t('continue')}
      </Button>
    </Flex>
  );
};
